import React from 'react';
import Card from '@common-web/card';
import { Flex } from 'antd';
import { NoInternetIcon } from '@common-web/icons';

const NoInternetBanner = () => {
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        position: 'fixed',
        top: 10, // or whatever vertical offset you want
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
      }}
    >
      <Card
        bodyStyle={{
          backgroundColor: 'var(--ant-color-primary)',
          padding: 18,
          borderRadius: 'var(--ant-border-radius-lg)',
        }}
      >
        <Flex align="center" justify="center" gap={8}>
          <NoInternetIcon />
          <p style={{ color: 'white', textAlign: 'center', margin: 0 }}>
            Check your internet/network connection and try again
          </p>
        </Flex>
      </Card>
    </Flex>
  );
};
export default NoInternetBanner;
